import React, { createContext, useContext, useEffect, ReactNode } from 'react';
import { wsService } from '../services/WebSocketService';

interface WebSocketContextValue {
  isInitialized: boolean;
}

const WebSocketContext = createContext<WebSocketContextValue>({
  isInitialized: false
});

export const useWebSocketContext = () => useContext(WebSocketContext);

interface WebSocketProviderProps {
  children: ReactNode;
}

export const WebSocketProvider: React.FC<WebSocketProviderProps> = ({ children }) => {
  useEffect(() => {
    // Initialize WebSocket connection on app start
    wsService.connect();

    // Request current state once connected
    const handleConnected = () => {
      wsService.requestCurrentState();
    };

    wsService.on('connected', handleConnected);

    return () => {
      wsService.off('connected', handleConnected);
      wsService.disconnect();
    };
  }, []);

  return (
    <WebSocketContext.Provider value={{ isInitialized: true }}>
      {children}
    </WebSocketContext.Provider>
  );
};